import { Attributes, Misc, ModelBase, NeoModel, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class UpdateOrganisationCommand extends ModelBase {

    public organisationId: number = 0;

    public nominatedCurrencyId: number = 0;

    public organisationName: string = "";

    // Client only properties / methods
    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}